/**
 * 网诊问卷模板模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

/* 网诊问卷模板 */
// 获取网诊问卷模板列表
export const templateList = (params) => {
  return req.get('/webchat/template/template/list', params);
}

// 获取网诊问卷模板列表数量
export const templateCount = (params) => {
  return req.get('/webchat/template/template/count', params);
}

// 新增网诊问卷模板
export const templateAdd = (params) => {
  return req.post('/webchat/template/template', params);
}

// 修改网诊问卷模板
export const templateEdit = (params) => {
  return req.put('/webchat/template/template', params);
}

// 删除网诊问卷模板
export const templateDelete = (ids) => {
  return req.delete(`/webchat/template/template/${ids}`);
}

/* 网诊问卷题目 */
// 获取网诊问卷题目列表
export const questionList = (params) => {
  return req.get('/webchat/template/question/list', params);
}

// 新增网诊问卷题目
export const questionAdd = (params) => {
  return req.post('/webchat/template/question', params);
}

// 修改网诊问卷题目
export const questionEdit = (params) => {
  return req.put('/webchat/template/question', params);
}

// 删除网诊问卷题目
export const questionDelete = (ids) => {
  return req.delete(`/webchat/template/question/${ids}`);
}

// 查询网诊问卷题目详情
export const questionDetails = (id) => {
  return req.get(`/webchat/template/question/${id}`);
}

/* 网诊问卷题目答案 */
// 获取题目答案列表
export const questionAnswerList = (params) => {
  return req.get('/webchat/template/answer/list', params);
}

// 新增题目答案
export const questionAnswerAdd = (params) => {
  return req.post('/webchat/template/answer', params);
}

// 修改题目答案
// export const questionAnswerEdit = (params) => {
//   return req.put('/webchat/template/answer', params);
// }

// 删除题目答案
export const questionAnswerDelete = (ids) => {
  return req.delete(`/webchat/template/answer/${ids}`);
}

/* 网诊问卷题库 */
// 获取网诊题库列表
/* export const questionBankList = (params) => {
  return req.get('/exam/question/bank/list', params);
}

// 获取网诊题库详情
export const questionBankDetails = (examQuestionBankId) => {
  return req.get(`/exam/question/bank/${examQuestionBankId}`);
}

// 新增网诊题库
export const questionBankAdd = (params) => {
  return req.post('/exam/question/bank', params);
}

// 修改网诊题库
export const questionBankEdit = (params) => {
  return req.put('/exam/question/bank', params);
}

// 删除网诊题库
export const questionBankDelete = (examQuestionBankId) => {
  return req.delete(`/exam/question/bank/${examQuestionBankId}`);
} */